import React from 'react'

const BtnLoader = ({ CustomeStyle }) => {
    return (
        <div className="loading">
            <span className={`${CustomeStyle}`}></span>
            <span className={`${CustomeStyle}`}></span>
            <span className={`${CustomeStyle}`}></span>
            <span className={`${CustomeStyle}`}></span>
            <span className={`${CustomeStyle}`}></span>
        </div>
    )
}

export default BtnLoader